import React from 'react'
import { StyledDivider } from './styled'

const Divider = () => <StyledDivider />

export default Divider
